import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCart } from "@/context/CartContext";

export function FloatingProceedButton() {
  const { cart, isCheckout, setIsCheckout, showSearch } = useCart();

  // Only show if: items in cart, not already in checkout, search results visible
  if (showSearch || cart.length === 0 || isCheckout) {
    return null;
  }

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
      <Button
        onClick={() => setIsCheckout(true)}
        className="h-12 md:h-14 px-6 md:px-10 bg-green-600 hover:bg-green-700 text-white font-semibold shadow-lg transition-all rounded-full animate-proceed-glow text-sm md:text-base whitespace-nowrap"
      >
        <CheckCircle className="w-4 h-4 md:w-5 md:h-5 mr-2" />
        Proceed to Booking
      </Button>
    </div>
  );
}
